import MessageList from './message-list.js';
import MessageBrokerUtils from './message-broker-utils.js';

export default MessageBrokerUtils.extractMessages(MessageList);
